// extracted by mini-css-extract-plugin
export default {"App":"App_App__nVroQ","App-logo":"App_App-logo__schIm","App-logo-spin":"App_App-logo-spin__nEskr","App-header":"App_App-header__0j1su","App-link":"App_App-link__0t0u4"};